import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { ICustomCta, ICustomCtaForm } from '@campaign-form/campaign-form.interface';
import { EAnalyticsStatus } from '@enums/campaign-analytics.enum';
import { EDeliverableType } from '@enums/campaign.enum';
import { IBase, IBaseDeliverableForm, IDeliverableBase } from '../../deliverable-list.interface';

export interface ITextDeliverableConfig {
  arrayFieldName: string;
  contentFieldName: string;
  highlightNamespace: string;
  subtitleTranslationKey: string;
  placeholderTranslationKey: string;
  addButtonTranslationKey: string;
  lastActiveCannotBeDeletedTranslationKey: string;
  type: TTextDeliverableConfigType;
}

export type TTextDeliverableType =
  | EDeliverableType.title
  | EDeliverableType.talkingPoint
  | EDeliverableType.textTracking
  | EDeliverableType.audioTracking
  | EDeliverableType.caption
  | EDeliverableType.hashTag
  | EDeliverableType.mention
  | EDeliverableType.message
  | EDeliverableType.description;

/**
 * Extends `TTextDeliverableType` with non-text types that reuse `TextDeliverableComponent`
 * via composition. Intentionally NOT added to `TTextDeliverableType` to keep the data-model
 * discriminated union clean (ITextDeliverable only covers true text deliverables).
 */
export type TTextDeliverableConfigType = TTextDeliverableType | EDeliverableType.chatbotMulti;

export interface IText extends IBase, ICustomCta {
  contents: ITextContent[];
  matchMode: ETextDeliverableMatchMode;
}

export interface ITextContent extends ICustomCta {
  analyticsCurrentCount?: number | null;
  analyticsTargetCount?: number | null;
  id: string;
  text: string;
  status?: EAnalyticsStatus;
}

export interface ITextDeliverable extends IDeliverableBase {
  type: TTextDeliverableType;
  contents: ITextContent[];
  matchMode: ETextDeliverableMatchMode;
}

export interface ITextDeliverableForm extends IBaseDeliverableForm {
  type: FormControl<TTextDeliverableType>;
  contents: FormArray<FormGroup<ITextContentForm>>;
  matchMode: FormControl<ETextDeliverableMatchMode>;
}

export interface ITextContentForm extends ICustomCtaForm {
  id: FormControl<string | null>;
  text: FormControl<string | null>;
  status: FormControl<EAnalyticsStatus | null>;
  analyticsCurrentCount: FormControl<number | null>;
}

export enum ETextDeliverableMatchMode {
  and = 'and',
  or = 'or',
}
